import React from "react";
import PT from "prop-types";

import "./hamburger-menu.m.css";
export function HamburgerMenu({ onClick }) {
  return (
    <button styleName="hamburger-menu" onClick={onClick}>
      <div styleName="bar"></div>
      <div styleName="bar"></div>
      <div styleName="bar"></div>
      <div className="sr-only">Menu</div>
    </button>
  );
}

HamburgerMenu.propTypes = {
  onClick: PT.func
};
